import { Logger, LoggerService } from '@Shared/logger';
import { EventUtil, UIUtil } from '@Shared/utils';
import { APP_EVENTS } from '@Core';
import { OnReadyEvent } from '@Modules/event_module';
import { EngageService } from '@Modules/engage_module';
import { PaywayOptions } from './_models';
import { PaywayService } from './services';
import { PAYWAY_UI_CONST } from './_models/conts';

export class PaywayModuleClass {
  private Logger: Logger = LoggerService.createLogger('PaywayModule');

  constructor() {
    this.Logger.trace('****  CTOR ****');
  }

  public async init(options: PaywayOptions): Promise<void> {
    if ( !window.apple_config?.loggedOutPurchaseEnabled || !window.apple_config?.applePayEnabled ) {
      this.Logger.trace( 'APPLE PAY | exiting - either using legacy code or apple pay not enabled' )
      return;
    }
    this.Logger.trace('APPLE PAY | Setting up Payway Module...');

    try {
      await PaywayService.Instance.init(); 

      return Promise.resolve();
    } catch (error) {
      throw error;
    }
  }
}

export const PaywayModule = new PaywayModuleClass();
